// Deprecated : please set emiModulesToUniverseRoot in your config file
// TODO:UNIVERSE_REFACTOR: remove this file
export default {
    root: 'root',
    home: 'root-coach',
    vod: 'root-vod',
}
